/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Batch } from './Batch';
import {
    BatchFromJSON,
    BatchFromJSONTyped,
    BatchToJSON,
} from './Batch';
import type { SelectedBatch } from './SelectedBatch';
import {
    SelectedBatchFromJSON,
    SelectedBatchFromJSONTyped,
    SelectedBatchToJSON,
} from './SelectedBatch';
import type { SerialNumber } from './SerialNumber';
import {
    SerialNumberFromJSON,
    SerialNumberFromJSONTyped,
    SerialNumberToJSON,
} from './SerialNumber';
import type { StorageLocation } from './StorageLocation';
import {
    StorageLocationFromJSON,
    StorageLocationFromJSONTyped,
    StorageLocationToJSON,
} from './StorageLocation';

/**
 * 
 * @export
 * @interface OutboundOrderItem
 */
export interface OutboundOrderItem {
    /**
     * Eindeutige ID des Auftragsartikels
     * @type {string}
     * @memberof OutboundOrderItem
     */
    id: string;
    /**
     * Artikelnummer
     * @type {string}
     * @memberof OutboundOrderItem
     */
    articleNumber: string;
    /**
     * Barcode des Artikels
     * @type {string}
     * @memberof OutboundOrderItem
     */
    barcode: string;
    /**
     * Artikelbeschreibung
     * @type {string}
     * @memberof OutboundOrderItem
     */
    description: string;
    /**
     * URL zum Produktbild
     * @type {string}
     * @memberof OutboundOrderItem
     */
    imageUrl: string;
    /**
     * Hauptlagerplatz
     * @type {string}
     * @memberof OutboundOrderItem
     */
    location: string;
    /**
     * Liste alternativer Lagerplätze
     * @type {Array<StorageLocation>}
     * @memberof OutboundOrderItem
     */
    storageLocations?: Array<StorageLocation>;
    /**
     * Benötigte Menge
     * @type {number}
     * @memberof OutboundOrderItem
     */
    requiredQty: number;
    /**
     * Bereits gepickte Menge
     * @type {number}
     * @memberof OutboundOrderItem
     */
    pickedQty: number;
    /**
     * Bereits versandte Menge
     * @type {number}
     * @memberof OutboundOrderItem
     */
    shippedQty: number;
    /**
     * Typ des Artikels (Standard, Chargen- oder Seriennummernverwaltung)
     * @type {string}
     * @memberof OutboundOrderItem
     */
    type: OutboundOrderItemTypeEnum;
    /**
     * Status des Artikels
     * @type {string}
     * @memberof OutboundOrderItem
     */
    status: OutboundOrderItemStatusEnum;
    /**
     * Verfügbare Chargen für diesen Artikel
     * @type {Array<Batch>}
     * @memberof OutboundOrderItem
     */
    batches?: Array<Batch>;
    /**
     * Ausgewählte Chargen für die Kommissionierung
     * @type {Array<SelectedBatch>}
     * @memberof OutboundOrderItem
     */
    selectedBatches?: Array<SelectedBatch>;
    /**
     * Seriennummern für diesen Artikel
     * @type {Array<SerialNumber>}
     * @memberof OutboundOrderItem
     */
    serialNumbers?: Array<SerialNumber>;
    /**
     * Gibt an, ob Pick-to-Light aktiv ist
     * @type {boolean}
     * @memberof OutboundOrderItem
     */
    pickToLightActive?: boolean;
}


/**
 * @export
 */
export const OutboundOrderItemTypeEnum = {
    Standard: 'standard',
    Batch: 'batch',
    Serial: 'serial',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type OutboundOrderItemTypeEnum = typeof OutboundOrderItemTypeEnum[keyof typeof OutboundOrderItemTypeEnum];

/**
 * @export
 */
export const OutboundOrderItemStatusEnum = {
    Pending: 'pending',
    Picking: 'picking',
    Completed: 'completed',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type OutboundOrderItemStatusEnum = typeof OutboundOrderItemStatusEnum[keyof typeof OutboundOrderItemStatusEnum];


/**
 * Check if a given object implements the OutboundOrderItem interface.
 */
export function instanceOfOutboundOrderItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "articleNumber" in value;
    isInstance = isInstance && "barcode" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "imageUrl" in value;
    isInstance = isInstance && "location" in value;
    isInstance = isInstance && "requiredQty" in value;
    isInstance = isInstance && "pickedQty" in value;
    isInstance = isInstance && "shippedQty" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function OutboundOrderItemFromJSON(json: any): OutboundOrderItem {
    return OutboundOrderItemFromJSONTyped(json, false);
}

export function OutboundOrderItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundOrderItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'articleNumber': json['articleNumber'],
        'barcode': json['barcode'],
        'description': json['description'],
        'imageUrl': json['imageUrl'],
        'location': json['location'],
        'storageLocations': !exists(json, 'storageLocations') ? undefined : ((json['storageLocations'] as Array<any>).map(StorageLocationFromJSON)),
        'requiredQty': json['requiredQty'],
        'pickedQty': json['pickedQty'],
        'shippedQty': json['shippedQty'],
        'type': json['type'],
        'status': json['status'],
        'batches': !exists(json, 'batches') ? undefined : ((json['batches'] as Array<any>).map(BatchFromJSON)),
        'selectedBatches': !exists(json, 'selectedBatches') ? undefined : ((json['selectedBatches'] as Array<any>).map(SelectedBatchFromJSON)),
        'serialNumbers': !exists(json, 'serialNumbers') ? undefined : ((json['serialNumbers'] as Array<any>).map(SerialNumberFromJSON)),
        'pickToLightActive': !exists(json, 'pickToLightActive') ? undefined : json['pickToLightActive'],
    };
}

export function OutboundOrderItemToJSON(value?: OutboundOrderItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'articleNumber': value.articleNumber,
        'barcode': value.barcode,
        'description': value.description,
        'imageUrl': value.imageUrl,
        'location': value.location,
        'storageLocations': value.storageLocations === undefined ? undefined : ((value.storageLocations as Array<any>).map(StorageLocationToJSON)),
        'requiredQty': value.requiredQty,
        'pickedQty': value.pickedQty,
        'shippedQty': value.shippedQty,
        'type': value.type,
        'status': value.status,
        'batches': value.batches === undefined ? undefined : ((value.batches as Array<any>).map(BatchToJSON)),
        'selectedBatches': value.selectedBatches === undefined ? undefined : ((value.selectedBatches as Array<any>).map(SelectedBatchToJSON)),
        'serialNumbers': value.serialNumbers === undefined ? undefined : ((value.serialNumbers as Array<any>).map(SerialNumberToJSON)),
        'pickToLightActive': value.pickToLightActive,
    };
}

